import { InputLabel, MenuItem, Select } from "@material-ui/core";
import React from "react";
var EnterpriseSelect = function (props) {
    var _a;
    var options = [];
    if (!props.notEmpty) {
        options.push(React.createElement(MenuItem, { key: "none", value: "none" }, "---"));
    }
    props.enterprises.forEach(function (e) {
        return options.push(React.createElement(MenuItem, { key: e.id, value: e.id }, e.name));
    });
    return (React.createElement("div", { key: props.key, className: "col s12 m6" },
        React.createElement(InputLabel, null, "Enterprise"),
        React.createElement(Select, { className: "select", key: props.key, onChange: function (e) {
                var id = e.target.value;
                props.setEnterprise(id);
            }, placeholder: "Enterprise", id: "enterprise" + ((_a = props.key) !== null && _a !== void 0 ? _a : ""), value: props.value, readOnly: props.readOnly, disabled: props.readOnly }, options),
        React.createElement("div", { className: "red-text", style: { marginBottom: "20px" } }, props.error && props.error)));
};
export default EnterpriseSelect;



//////////////////
// WEBPACK FOOTER
// ./src/components/common/EnterpriseSelect.tsx
// module id = 95
// module chunks = 0